import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <p>Loading...</p>;
  if (!user) return <Navigate to="/" replace />;
  if (user.user_type !== "admin") {
    return <Navigate to={`/redp/${user.id}`} replace />;
  }
  return children;
};

export default AdminRoute;
